import styled from 'styled-components'
import { Link } from '@at/design-system-elements'
import { ThemeSelectors } from '@at/design-system-foundation'

export const StyledSearchBackToDealerLink = styled(Link)`
    padding: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)} 0;
    && {
        svg {
            fill: ${({ theme }) => theme.color.text.link.default};
            margin-right: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 0.5}px;
        }
        border-bottom-color: transparent;
        color: ${({ theme }) => theme.color.text.link.default};
        width: fit-content;
    }
`
